import { render } from "./SubjectForm.vue?vue&type=template&id=49b11daa&ts=true"
import script from "./SubjectForm.ts?vue&type=script&lang=ts"
export * from "./SubjectForm.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__